import React from 'react'
import cn from 'classnames'
import PropTypes from 'prop-types'
import sprite from '../../img/sprite.svg'

function SpriteSvg({
   id,
   className,
   style,
   width,
   height,
   color,
}) {
  return(
    <svg
      style={style}
      width={width}
      height={height}
      fill={color ? color : 'var(--black-60)'}
      className={cn(`${id}`, className)}
    >
      <use xlinkHref={`${sprite}#${id}`} />
    </svg>
  )
}

SpriteSvg.propTypes = {
  name: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  width: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  height: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
}

export default SpriteSvg
